(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-style3"] && !Shopify.designMode) return;
  try {
    
    var modal = document.getElementById("myModal");
    var body = document.getElementById("grillaholics-grilling-accessoriess");
	var btn = document.getElementById("myBtn");
    var span = document.getElementsByClassName("close")[0];
    btn.onclick = function() {
      modal.style.display = "block";
      body.classList.add("noscroll");
    }
    span.onclick = function() {
      modal.style.display = "none";
      body.classList.remove("noscroll");
    }
    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-Drawer"]) return;
  try {
    
window.SectionCartDrawer = (function(){
function SectionCartDrawer() {
  this._run();
}

SectionCartDrawer.prototype = {
  _run: function() {
    update_shipping_bar(VastaShop.Cart.current.total_price, VastaShop.Cart.current.item_count);

    if(!disable_cartDrawer){
      var _add_to_cart = jQuery('.jq-cart-add-product');

      _add_to_cart.submit(function () {
        $('#add-to-cart-error').html('');
        jQuery('.btn-add-tocart').prop('disabled', true);
        jQuery('.btn-add-tocart .btn-progress').animate({ width: '30%'}, 250);

        VastaShop.Cart.addItem(jQuery(this).serialize()).then(function (prod, status) {
          if ('success' == status) {
            VastaShop.Cart.getAllItems().then(function(cart, status){
              if ('success' === status) {
                jQuery('.btn-add-tocart .btn-progress').animate({ width: '100%'}, 250, function(){
                    jQuery(this).css('width', '0').show();
                });

                VastaShop.Cart.current = cart;

                jQuery('.cupom-text').show();
                render_cart_drawer(VastaShop.Cart.current, jQuery('.list-products'), 0,'');

                update_shipping_bar(cart.total_price,cart.item_count);

                jQuery('.btn-add-tocart').prop('disabled', false);
                jQuery('body').addClass('cart-drawer-open cart-open');
                jQuery('#CartStatus').text('');
                window.setTimeout(function() {
                  jQuery('#CartStatus').text(cart_added_status);
                }, 0);
                inventoryControl(prod.id);
              }
            }).catch(function(err) {
              console.log(err);
            });
          }
        }).catch(function(err) {
          if (err.status === 422) {
            var product_variants = $('#all-product-variants'),
                max_allowed = parseInt($('option:selected', product_variants).data('inventory')),
                variant_in_cart = VastaShop.Cart.current.items.filter(function(e){
                  return e.id == product_variants.val();
                }),
                quantity_limit_message;

            jQuery('.btn-add-tocart .btn-progress').animate({ width: '100%'}, 250, function(){
              jQuery(this).css('width', '0').show();
              $('.btn-add-tocart').attr('disabled', false);
            });
            
            if (variant_in_cart.length > 0) {
              quantity_limit_message = max_allowed - variant_in_cart[0].quantity;

              if (quantity_limit_message > 0) {
                quantity_limit_message = 'You can only add ' + quantity_limit_message + (quantity_limit_message != 1 ? ' units of this product variants.': 'unit of this product variant.');
              } else {
                quantity_limit_message = 'This variant can\'t be added anymore';
              }

              $('#add-to-cart-error').html( quantity_limit_message );
            }
          } else {
            throw err;
          }
        });

        return false;
      });
    }

    $('.list-products').on('click','.cart-product-wrapper',function(){
      if($(this).find('.jq-plus-cart-item').attr('disabled') == 'disabled'){
          $(this).find('.jq-plus-cart-item').removeAttr('disabled');
      }
    });

    if (!jQuery('body').hasClass('template-cart')) {
      jQuery('.list-products').click('.jq-minus-cart-item', function (e) {
        var item = jQuery(e.target).eq(0);

        if (item.hasClass('jq-plus-cart-item')) {
            plusItem(item, '.input-qtd');
        } else if (item.hasClass('jq-minus-cart-item')) {
            minusItem(item, '.input-qtd');
        } else if (item.hasClass('bt-remove-cart')){
          removeItem('.jq-remove-cart-item', '#jq-cart-item-', '.jq-total-price', item.attr('name'), item);
          return false;
        }
      });

      jQuery('.list-products').on('submit', '.jq-qtd-item-cart', function(e){
        var data = $(this).serializeArray();
        var OlD = $(this).find('.input-qtd').prop('defaultValue');

        $('#CartDrawer form').attr('disabled', 'disabled');

        VastaShop.Cart.change(data).then(function(cart){
          VastaShop.Cart.current = cart;
          render_cart_drawer( cart, jQuery('.list-products'),OlD, data[0].value.split(':')[0] );
          inventoryControl(data[0].value.split(':')[0]);
          
          update_shipping_bar(VastaShop.Cart.current.total_price, VastaShop.Cart.current.item_count);
        }).catch(function(err) {
            console.log(err);
        });

        return false;
      });
    }

    if (!jQuery('body').hasClass('template-cart')){
      jQuery('.list-products').on('change ', '.input-qtd', function (e) {
        var input_qtd = jQuery(this).eq(0),
            item = jQuery(e.target).eq(0);

        if(input_qtd.val() < 1){
          input_qtd.val(1);
        }

        if(input_qtd.val() >= parseInt(input_qtd.attr('data-max')) && parseInt(input_qtd.attr('data-max')) != -1){
          input_qtd.val(parseInt(input_qtd.attr('data-max')));
          input_qtd.parent().find('.jq-minus-cart-item').removeAttr('disabled');
        }else if(input_qtd.val() < parseInt(input_qtd.attr('data-max')) && parseInt(input_qtd.attr('data-max')) != -1){
          input_qtd.parent().find('.jq-plus-cart-item').removeAttr('disabled');
          input_qtd.parent().find('.jq-minus-cart-item').removeAttr('disabled');
        }

        jQuery('.list-products').trigger('submit');
      });
    }

    jQuery('.list-products').on('blur ', '.input-qtd', function (e) {
      jQuery(this).submit();
    })

    jQuery('.main-header .open-drawer').click(function(){
      if( !jQuery('body').hasClass('cart-drawer-open') && $(this).is('span'))
        jQuery('body').addClass('cart-drawer-open cart-open');
    });

    jQuery('.cart-drawer .fallback-text').click(function(){
      if( jQuery('body').hasClass('cart-open') )
        jQuery('body').removeClass('cart-open cart-drawer-open');
    });
  },

  onLoad: function(){
    update_shipping_bar(VastaShop.Cart.current.total_price, VastaShop.Cart.current.item_count);
  },

  onSelect: function() {
    this._run();
  },

  onUnload: function() {
    jQuery('.main-header .open-drawer').off('click');
    jQuery('.cart-drawer .fallback-text').off('click');
    jQuery('.list-products').off('click');
  }
};

return new SectionCartDrawer;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
window.SectionFooter = (function(){
  function SectionFooter() {
    this._run();
  }

  SectionFooter.prototype = {
    _run: function() {
      if ( $(window).width() < 768 ) {
        $('.site-footer .menu-footer-grid').addClass('clickable');
        $('.site-footer .footer-menu-toggle').attr('aria-expanded', 'false');
      } else {
		    $('.site-footer .menu-footer-grid').removeClass('clickable');
        $('.site-footer .footer-menu-toggle').attr('aria-expanded', 'true');
      }

		$(window).resize(function(){
      if ( $(window).width() < 768 ) {
        $('.site-footer .menu-footer-grid').addClass('clickable');
        $('.site-footer .menu-footer-grid .no-bullets').hide();
        $('.site-footer .footer-menu-toggle').attr('aria-expanded', 'false');
      } else {
        $('.site-footer .menu-footer-grid').removeClass('clickable');
        $('.site-footer .menu-footer-grid .no-bullets').show();
		$('.site-footer .footer-menu-toggle').attr('aria-expanded', 'true');
		  }
		});

		$('.site-footer .footer-menu-toggle').click(function(){
          var menuGrid = $(this).closest('.menu-footer-grid');
		  	if (menuGrid.length) {
          var menuList = menuGrid.children('.no-bullets');
          var wasVisible = menuList.is(':visible');

          $('.site-footer .menu-footer-grid .no-bullets').stop().slideUp();
          $('.site-footer .footer-menu-toggle').attr('aria-expanded', 'false');
          $('.site-footer .nav-title').removeClass('row-rotate');

          if (!wasVisible) {
            menuGrid.children('.nav-title').addClass('row-rotate');
            menuList.stop().slideDown();
            $(this).attr('aria-expanded', 'true');
          }
      }
      });
    },

    onLoad: function() {
      this._run();
    },

    onUnload: function() {

    }
  };

  return new SectionFooter;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
window.SectionHeader = (function(){
  function SectionHeader() {
    this._cartDrawerObserver = null;
    this._run();
  }

  SectionHeader.prototype = {
    _run: function() {
      var cartDrawerWasOpen = $('body').hasClass('cart-drawer-open');

      function syncCartDrawerState() {
        var isOpen = $('body').hasClass('cart-drawer-open');
        var cartDrawer = $('#CartDrawer');

        cartDrawer
          .attr('aria-hidden', isOpen ? 'false' : 'true')
          .prop('inert', !isOpen);
        $('.main-header .cart-icon').attr('aria-expanded', isOpen ? 'true' : 'false');

        if (isOpen && !cartDrawerWasOpen) {
          window.setTimeout(function() {
            if (!$.contains(cartDrawer[0], document.activeElement)) {
              cartDrawer.find('.fallback-text').first().trigger('focus');
            }
          }, 0);
        }

        cartDrawerWasOpen = isOpen;
      }

      if (!this._cartDrawerObserver && document.body) {
        this._cartDrawerObserver = new MutationObserver(function(mutations) {
          if (mutations.some(function(mutation) { return mutation.attributeName === 'class'; })) {
            syncCartDrawerState();
          }
        });
        this._cartDrawerObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        syncCartDrawerState();
      }

      $(document).on('click', '.main-header .cart-icon', function(){
        if( !$('body').hasClass('cart-drawer-open') ) {
          $('body').addClass('cart-drawer-open cart-open');
          $('#CartDrawer').removeAttr('inert').attr('aria-hidden', 'false');
          $(this).attr('aria-expanded', 'true');
          $('#CartDrawer').trigger('focus');
        }
      });

      $(document).on('click', '.cart-drawer .fallback-text', function(){
        $('body').removeClass('cart-open cart-drawer-open');
        $('#CartDrawer').attr('aria-hidden', 'true').attr('inert', '');
        $('.main-header .cart-icon').attr('aria-expanded', 'false').trigger('focus');
      });

      $(document).on('click', '.DrawerOverlay', function(){
        var cartWasOpen = $('body').hasClass('cart-drawer-open') || $('#CartDrawer').attr('aria-hidden') === 'false';
        $('body').removeClass('js-drawer-open-left cart-open cart-drawer-open');
        $('#CartDrawer').attr('aria-hidden', 'true').attr('inert', '');
        $('.main-header .cart-icon').attr('aria-expanded', 'false');
        if (cartWasOpen) {
          $('.main-header .cart-icon').trigger('focus');
        }
      });

      $(document).on('keydown.cartDrawer', function(event){
        if (event.key === 'Escape' && $('body').hasClass('cart-drawer-open')) {
          $('body').removeClass('cart-open cart-drawer-open');
          $('#CartDrawer').attr('aria-hidden', 'true').attr('inert', '');
          $('.main-header .cart-icon').attr('aria-expanded', 'false').trigger('focus');
        }

        if (event.key === 'Tab' && $('body').hasClass('cart-drawer-open')) {
          var cartDrawer = $('#CartDrawer');
          var focusable = cartDrawer.find('a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])').filter(':visible');
          var first = focusable.first();
          var last = focusable.last();

          if (!focusable.length) {
            event.preventDefault();
            cartDrawer.trigger('focus');
          } else if (!$.contains(cartDrawer[0], document.activeElement)) {
            event.preventDefault();
            first.trigger('focus');
          } else if (event.shiftKey && document.activeElement === first[0]) {
            event.preventDefault();
            last.trigger('focus');
          } else if (!event.shiftKey && document.activeElement === last[0]) {
            event.preventDefault();
            first.trigger('focus');
          }
        }
      });
    },

    onSelect: function() {
      this._run();
    },

    onUnload: function() {
      $('.main-header .cart-icon').off('click');
      $('.cart-drawer .fallback-text').off('click');
      $('.DrawerOverlay').off('click');
      $(document).off('keydown.cartDrawer');
      if (this._cartDrawerObserver) {
        this._cartDrawerObserver.disconnect();
        this._cartDrawerObserver = null;
      }
    }
  };

  return new SectionHeader;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-mobile-uvc-slider"] && !Shopify.designMode) return;
  try {
    
window.SectionValuePropositionIcons = (function(){
  function SectionValuePropositionIcons() {
    this.settings = {
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow: '<button type="button" class="slick-prev">&lang;</button>',
      nextArrow: '<button type="button" class="slick-next">&rang;</button>',
      arrows: true,
      responsive: [
          {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
          }
      ]
    };

    this._run();
  }

  SectionValuePropositionIcons.prototype = {
    onLoad: function() {
      this._run();
    },

    _run: function() {
      var slider, autoplay, autoplaySpeed, settings = this.settings;

      jQuery('[id^="value-proposition-icons-"]').each(function(){
        slider = '#value-proposition-icons-' + $(this).data('slider');
        
        autoplay = jQuery(slider).data('autoplay');
        autoplaySpeed = jQuery(slider).data('speed');

        if (typeof autoplay !== 'undefined' && autoplay != true && autoplay != false) {
          autoplay = true;
        }

        if (typeof autoplaySpeed !== 'undefined' && autoplaySpeed < 800 && autoplaySpeed > 3000) {
          autoplaySpeed = 800;
        }

        settings.autoplay = autoplay;
        settings.autoplaySpeed = autoplaySpeed;
        
        var sliderElement = jQuery(slider);
        sliderElement.not('.slick-initialized').slick( settings );
        sliderElement.find('.slick-prev').attr('aria-label', sliderElement.data('previous-label'));
        sliderElement.find('.slick-next').attr('aria-label', sliderElement.data('next-label'));

        jQuery('[data-carousel-pause="' + jQuery(this).data('slider') + '"]')
          .off('click.adaCarousel')
          .on('click.adaCarousel', function() {
            var pauseButton = jQuery(this);
            var isPaused = pauseButton.attr('data-paused') === 'true';

            if (isPaused) {
              sliderElement.slick('slickPlay');
              pauseButton.attr('data-paused', 'false').text(pauseButton.data('pause-label'));
            } else {
              sliderElement.slick('slickPause');
              pauseButton.attr('data-paused', 'true').text(pauseButton.data('play-label'));
            }
          });
      });
    }
  };

  return new SectionValuePropositionIcons;
})();    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instafeed-theme"] && !Shopify.designMode) return;
  try {
    
function formatInstagramDate( image ) {
    var monthNames,
        date = new Date(image.created_time * 1000);

    m = date.getMonth();
    d = date.getDate();
    y = date.getFullYear();

    monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    image.created_time = monthNames[m] + ' ' + d + ', ' + y;

    return true;
}

window.SectionInstafeed = (function(){
    function SectionInstafeed() {
        this.section = null;
        this.data = null;

        this._run();
    }

    function getResolution( data ) {
        return (jQuery(window).width() < 767 || data.image_per_row > 4) ? 'low_resolution' : 'standard_resolution';
    }

    function newInstafeed( data, resolution, limitphoto ) {
        return new Instafeed({
            get: 'user',
            userId: 'self',
            accessToken: data.access_token,
            sortBy: 'most-recent',
            limit: limitphoto,
            resolution: resolution,
            template: data.template,

            after: function() {
                var images = $('.instagram__image-wrapper');
    
                images.filter(':nth-child(2n + 1)').addClass('grid__item--mobile-first');
                images.filter(':nth-child(' + data.image_per_row + 'n + 1)').addClass('grid__item--tablet-first grid__item--desktop-first');
            },
            filter: $.proxy(formatInstagramDate)
        });
    }

    function runInstafeed( data ) {
        var resolution, limitphoto;

        if (data.access_token) {
            resolution = getResolution( data ) ;

            if(jQuery(window).width() < 767) {
                limitphoto = 6;
            } else {
                limitphoto = data.image_per_row * data.rows;

                var feed = newInstafeed( data, resolution, limitphoto );

                console.log('<<<<', feed);
            
                feed.run();
            }
        }
    }

    SectionInstafeed.prototype = {
        _run: function() {
            this.section = document.querySelector('[data-section-type="instafeed"]');

            if (this.section) {
                this.data = {
                    access_token: this.section.getAttribute('data-access-token'),
                    rows: this.section.getAttribute('data-rows'),
                    image_per_row: this.section.getAttribute('data-image-per-row'),
                    template: '<div class="instagram__image-wrapper"><a href="{{link}}" id="{{id}}" target="_blank"><div class="instagram__overlay"><p class="instagram__caption">{{caption}}</p><time class="instagram__date">{{model.created_time}}</time></div><img class="instagram__image lazy" src="{{image}}" data-src="{{image}}"/></a></div>'
                };

                runInstafeed( this.data );
            }
        },

        onLoad: function() {
            this._run();
        },
    };

    return new SectionInstafeed;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-mobile"]) return;
  try {
    
$(document).on('click', '#IconMenuTextMobile, #NavDrawer .js-drawer-close button', function(){
  var drawer = $('#NavDrawer');
  var trigger = $('#IconMenuTextMobile');
  if($('body').hasClass('js-drawer-open-left')) {
    $('body').removeClass('js-drawer-open-left');
    drawer.attr('aria-hidden', 'true');
    drawer.attr('inert', '');
    trigger.attr('aria-expanded', 'false').trigger('focus');
  } else {
    $('.main-content').addClass('is-moved-by-drawer');
    $('.fixed').addClass('is-moved-by-drawer');
    $('.shopify-section header').addClass('is-moved-by-drawer');
    $('.search').addClass('is-moved-by-drawer');
    $('body').addClass('js-drawer-open-left');
    drawer.attr('aria-hidden', 'false');
    drawer.removeAttr('inert');
    trigger.attr('aria-expanded', 'true');
    drawer.find('button, a, input, select, textarea').filter(':visible').first().trigger('focus');
  }
});

$(document).on('click', '.DrawerOverlay', function(){
  $('body').removeClass('js-drawer-open-left cart-open cart-drawer-open');
  $('#NavDrawer').attr('aria-hidden', 'true');
  $('#NavDrawer').attr('inert', '');
  $('#IconMenuTextMobile').attr('aria-expanded', 'false').trigger('focus');
});

$(document).on('click', '.mobile-nav__toggle-open,.mobile-nav__link[href^="#"]', function(){
  var instance = $(this);

  instance.parent().siblings('.child').slideToggle(400);

  if (instance.is('.mobile-nav__link')) {
    instance = instance.siblings('.mobile-nav__toggle-open');;
  }

  if( instance.hasClass('anime-plus-ver') ) {
    instance.removeClass('anime-plus-ver anime-plus-hor');
    instance.attr('aria-expanded', 'false');
    $('#' + instance.attr('aria-controls')).attr('aria-hidden', 'true');
  } else {
    instance.addClass('anime-plus-ver anime-plus-hor');  
    instance.attr('aria-expanded', 'true');
    $('#' + instance.attr('aria-controls')).attr('aria-hidden', 'false');
  }
});

$(document).on('keydown', function(event){
  if (event.key === 'Escape' && $('body').hasClass('js-drawer-open-left')) {
    $('body').removeClass('js-drawer-open-left');
    $('#NavDrawer').attr('aria-hidden', 'true');
    $('#NavDrawer').attr('inert', '');
    $('#IconMenuTextMobile').attr('aria-expanded', 'false').trigger('focus');
  }

  if (event.key === 'Tab' && $('body').hasClass('js-drawer-open-left')) {
    var drawer = $('#NavDrawer');
    var focusable = drawer.find('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(':visible');
    var first = focusable.first();
    var last = focusable.last();

    if (!focusable.length) {
      event.preventDefault();
      drawer.trigger('focus');
    } else if (!$.contains(drawer[0], document.activeElement)) {
      event.preventDefault();
      first.trigger('focus');
    } else if (event.shiftKey && document.activeElement === first[0]) {
      event.preventDefault();
      last.trigger('focus');
    } else if (!event.shiftKey && document.activeElement === last[0]) {
      event.preventDefault();
      first.trigger('focus');
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"]) return;
  try {
    
(function($){
    var $document = $(document);

    $document.ready(function(){
        function activateTab(tabs) {
            var scope = tabs.parent().attr('data-tabs-scope');

            tabs.addClass('active').siblings().removeClass('active');

            tabs.find('[role="tab"]').attr({'aria-selected': 'true', 'tabindex': '0'});
            tabs.siblings().find('[role="tab"]').attr({'aria-selected': 'false', 'tabindex': '-1'});

            $('.tabs-content[data-tabs-scope="' + scope + '"] .tab-content[data-identifier="' + tabs.attr('data-target') + '"]').addClass('active').removeAttr('hidden').siblings().removeClass('active').attr('hidden', 'hidden');
        }

        $document.on('click', '.tabs', function(){
            activateTab.call(this, $(this));

            return false;
        });

        $document.on('keydown', '[role="tab"]', function(event){
            var tabs = $(this).closest('.tabs'),
                nextTab;

            if (event.key === 'ArrowRight') {
                nextTab = tabs.next('.tabs').length ? tabs.next('.tabs') : tabs.siblings('.tabs').first();
            } else if (event.key === 'ArrowLeft') {
                nextTab = tabs.prev('.tabs').length ? tabs.prev('.tabs') : tabs.siblings('.tabs').last();
            } else if (event.key === 'Home') {
                nextTab = tabs.siblings('.tabs').addBack().first();
            } else if (event.key === 'End') {
                nextTab = tabs.siblings('.tabs').addBack().last();
            } else {
                return;
            }

            event.preventDefault();
            activateTab.call(nextTab, nextTab);
            nextTab.find('[role="tab"]').focus();
        });
    });
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
window.SectionReviews = (function(){
  function SectionReviews() {
    this.settings = {
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow: '<button type="button" class="slick-prev">&lang;</button>',
      nextArrow: '<button type="button" class="slick-next">&rang;</button>',
      arrows: true,
      responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1019,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
          }
      ]
    };

    this._run();
  }

  SectionReviews.prototype = {
    onLoad: function() {
      this._run();
    },

    _run: function() {
      var slider, autoplay, autoplaySpeed,
          settings = this.settings;

      jQuery('[id^="slider-reviews-"]').each(function(){
        slider = '#slider-' + $(this).data('slider');

        autoplay = jQuery(slider).data('autoplay');
        autoplaySpeed = jQuery(slider).data('speed');

        if (typeof autoplay !== 'undefined' && autoplay != true && autoplay != false) {
          autoplay = true;
        }

        if (typeof autoplaySpeed !== 'undefined' && autoplaySpeed < 800 && autoplaySpeed > 3000) {
          autoplaySpeed = 800;
        }

        var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        settings.autoplay = autoplay && !prefersReducedMotion;
        settings.autoplaySpeed = autoplaySpeed;

        var sliderElement = jQuery(slider);
        sliderElement.not('.slick-initialized').slick( settings );
        sliderElement.find('.slick-prev').attr('aria-label', sliderElement.data('previous-label'));
        sliderElement.find('.slick-next').attr('aria-label', sliderElement.data('next-label'));

        var pauseButton = jQuery('[data-reviews-carousel-toggle="' + jQuery(this).data('slider') + '"]');
        if (prefersReducedMotion) {
          pauseButton.attr('data-paused', 'true').text(pauseButton.data('play-label'));
        }

        pauseButton
          .off('click.adaReviewsCarousel')
          .on('click.adaReviewsCarousel', function() {
            var toggle = jQuery(this);
            var isPaused = toggle.attr('data-paused') === 'true';

            if (isPaused) {
              sliderElement.slick('slickPlay');
              toggle.attr('data-paused', 'false').text(toggle.data('pause-label'));
            } else {
              sliderElement.slick('slickPause');
              toggle.attr('data-paused', 'true').text(toggle.data('play-label'));
            }
          });
      });
    }
  };

  return new SectionReviews;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping_bar"]) return;
  try {
    
  window.SectionShippingBar = (function(){
    function SectionShippingBar() {
      this._run();
    }
  
    SectionShippingBar.prototype = {
      _run: function() {
  
      },
  
      onSelect: function() {
        this._run();
      },
  
      onUnload: function() {
  
      }
    };
  
    return new SectionShippingBar;
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-promotional"] && !Shopify.designMode) return;
  try {
    
window.SectionSliderPromotional = (function(){
  function SectionSliderPromotional() {
    this.settings = {
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow: '<button type="button" class="slick-prev">&lang;</button>',
      nextArrow: '<button type="button" class="slick-next">&rang;</button>',
      arrows: true,
      responsive: [
          {
              breakpoint: 1180,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              }
          },
          {
              breakpoint: 1019,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
          },
          {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
          }
      ]
    };

    this._run();
  }

  SectionSliderPromotional.prototype = {
    onLoad: function() {
      this._run();
    },

    _run: function() {
      var slider, autoplay, autoplaySpeed, settings = this.settings;

      jQuery('[id^="slider-promotional-"]').each(function(){
        slider = '#promotional-' + $(this).data('slider');
        
        autoplay = jQuery(slider).data('autoplay');
        autoplaySpeed = jQuery(slider).data('speed');

        if (typeof autoplay !== 'undefined' && autoplay != true && autoplay != false) {
          autoplay = true;
        }

        if (typeof autoplaySpeed !== 'undefined' && autoplaySpeed < 800 && autoplaySpeed > 3000) {
          autoplaySpeed = 800;
        }

        settings.autoplay = autoplay;
        settings.autoplaySpeed = autoplaySpeed;
        
        jQuery(slider).not('.slick-initialized').slick( settings );
      });
    }
  };

  return new SectionSliderPromotional;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos"] && !Shopify.designMode) return;
  try {
    

window.SectionVideoSlider = (function(){
  function SectionVideoSlider() {
    this.settings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev">&lang;</button>',
      nextArrow: '<button type="button" class="slick-next">&rang;</button>',
      infinite: true
    };

    this._run();
  }

  SectionVideoSlider.prototype = {
    onLoad: function() {
      this._run();
    },

    _run: function() {
      var slider,
          settings = this.settings;

      jQuery('[id^="video-slider-"]').each(function(){
        slider = '#slider-' + $(this).data('slider');

        jQuery(slider).not('.slick-initialized').slick( settings );
      });
    }
  };

  return new SectionVideoSlider;
})();


  } catch(e) { console.error(e); }
})();
})();
